var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"recent-debates"},_vm._l((_vm.listTopics),function(topic){return _c('li',{key:topic.id},[_c('h6',[_c('router-link',{attrs:{"to":{ path: ("/topics/" + (topic.id)) }}},[_vm._v(" "+_vm._s(topic.title)+" ")])],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }